module.exports = __webpack_public_path__ + "img/14.01a30e51.png";